<!--
 * @Date: 2023-11-27 11:21:08
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-11-27 13:30:14
 * @FilePath: /Client/src/views/goods/components/D2DRedirect.vue
 * @Description:
-->
<template>
  <div class="container">
    <div class="bg">
      <img src="https://static-s.theckb.com/BusinessMarket/Client/d2dLoading_bg.png" style="width: 567px" alt="" srcset="">
      <img class="airport" src="https://static-s.theckb.com/BusinessMarket/Client/d2dLoading_icon.png" alt="" srcset="">
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
@keyframes fly {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(180px,0);
  }

}
.container {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 2001;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .bg{
    position: relative;
    .airport{
      position: absolute;
      left: 150px;
      top: 95px;
      animation: fly 1.5s ease-in-out infinite;
    }
  }
}
</style>
